const expression = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;

export default function timeExpressionValidator(value) {
	if (!value || !value.match || !value.match(expression)) {
		return 'Field is not in correct time format: hh:mm.';
	}

	return null;
}
